import { render } from "./PremiumUnlockDialog.vue?vue&type=template&id=66a06a5c&scoped=true"
import script from "./PremiumUnlockDialog.vue?vue&type=script&lang=js"
export * from "./PremiumUnlockDialog.vue?vue&type=script&lang=js"

import "./PremiumUnlockDialog.vue?vue&type=style&index=0&id=66a06a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a06a5c"]])

export default __exports__